import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import teamPhoto from "@/assets/team-photo.webp";

export const Team = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section className="py-24 bg-gradient-dark noise-overlay">
      <div className="container mx-auto px-4" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          className="text-center mb-12"
        >
          <span className="text-primary font-semibold tracking-wider uppercase text-sm">
            Our Team
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mt-4">
            Meet the Crew
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.2 }}
          className="relative rounded-2xl overflow-hidden shadow-elevated max-w-5xl mx-auto"
        >
          <img
            src={teamPhoto}
            alt="The Onyx Professional Plumbing team - Licensed plumbers serving Gulf Shores, Orange Beach, Foley, Fairhope and Daphne Alabama"
            className="w-full h-auto object-cover"
            width="1200"
            height="675"
            loading="lazy"
            decoding="async"
          />
        </motion.div>
      </div>
    </section>
  );
};
